import { render, staticRenderFns } from "./CCBrands.vue?vue&type=template&id=76dda9de&"
import script from "./CCBrands.vue?vue&type=script&lang=js&"
export * from "./CCBrands.vue?vue&type=script&lang=js&"
import style0 from "./CCBrands.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports